import React, { useCallback, useContext, useEffect, useRef, useState } from 'react'
import { Col, Row, Card, Table } from '@themesberg/react-bootstrap'
import { getAllUsers, updateStatus } from '../../../../controller/api/user'
import UserAmount from '../sub-screen/user-amount/UserAmount'
import { useCookies } from 'react-cookie'
import { TableRow } from '../component/TableRow'
import { calculatePage, formatNumber } from '../../../../helper/helper'
import Pagination from '../../../../components/Pagination'
import { Context } from '../User'
import PinModal from '../sub-screen/pin-modal/PinModal'

const CountCard = ({ title, value, detail, variant = 'info', formatted = true }) => (
  <Col xs={12} sm={6} xl={3} className="mb-3">
    <Card border="light" className="shadow-sm h-100">
      <Card.Body>
        <span className="d-block text-muted small mb-2">{title}</span>
        <span className={`h3 fw-bold text-${variant}`}>{formatted ? formatNumber(value) : value}</span>
        {detail && <span className="d-block text-muted small mt-2">{detail}</span>}
      </Card.Body>
    </Card>
  </Col>
)

const BalanceCard = ({ title, amount, reward }) => (
  <Col xs={12} xl={6} className="mb-3">
    <Card border="light" className="shadow-sm h-100">
      <Card.Body>
        <h6 className="text-muted mb-3">{title}</h6>
        <Row>
          <Col xs={6}>
            <span className="d-block text-muted small">Tổng số dư</span>
            <span className="h5 fw-bold text-info">{formatNumber(amount)}</span>
          </Col>
          <Col xs={6}>
            <span className="d-block text-muted small">Tổng thưởng</span>
            <span className="h5 fw-bold text-success">{formatNumber(reward)}</span>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  </Col>
)

const _Table = () => {

  const { state, walletPhoneFromQuery } = useContext(Context);

  const [cookies] = useCookies(['lottmekong'])

  const [data, setData] = useState({})

  const [page, setPage] = useState(0)
  const requestIdRef = useRef(0)

  const getAllFunc = useCallback(async () => {
    const requestId = ++requestIdRef.current
    const response = await getAllUsers(cookies.lottmekong, state, page)

    if (response && requestId === requestIdRef.current) {
      const res = {
        list: response.data,
        total: response.total,
        totalPage: calculatePage(response.total),
        totalAmount: response.totalAmount,
        totalRewardAmount: response.totalRewardAmount,
        grandTotalAmount: response.grandTotalAmount,
        grandTotalRewardAmount: response.grandTotalRewardAmount,
        grandTotal: response.grandTotal,
        newUsersThisMonth: response.newUsersThisMonth,
        activeTotal: response.activeTotal,
        inactiveTotal: response.inactiveTotal
      }
      setData(res || {})
    }
  }, [cookies.lottmekong, state, page])

  useEffect(() => {
    setPage(0)
  }, [state])

  const [modalShow, setModalShow] = useState(Boolean(walletPhoneFromQuery))

  const [pinModalShow, setPinModalShow] = useState(false);

  const userPhoneRef = useRef(walletPhoneFromQuery || null)

  const _userId = useRef('');

  useEffect(() => {
    getAllFunc()
  }, [getAllFunc])

  const onShowUserAmount = (phone) => {
    userPhoneRef.current = phone
    setModalShow(true)
  }

  useEffect(() => {
    if (!walletPhoneFromQuery) return

    userPhoneRef.current = walletPhoneFromQuery
    setModalShow(true)
  }, [walletPhoneFromQuery])

  const onAssignPin = (id) => {
    _userId.current = id
    setPinModalShow(true)
  }

  const onStatusChange = async (evt, id) => {
    const newStatus = evt.target.value
    const resp = await updateStatus(cookies.lottmekong, id, newStatus)
    if (resp) {
      window.location.reload()
    } else {
      alert('Có lỗi xảy ra')
      return false
    }
  }

  return (
    <>
      <Row>
        <CountCard title="Tổng số khách hàng" value={data.grandTotal} detail={`${formatNumber(data.activeTotal)} hoạt động · ${formatNumber(data.inactiveTotal)} ngừng`} />
        <CountCard title="Đăng ký trong tháng" value={data.newUsersThisMonth} variant="success" />
        <CountCard title="Kết quả theo bộ lọc" value={data.total} variant="primary" />
        <CountCard title="Tỷ lệ kết quả" value={data.grandTotal ? `${((data.total || 0) * 100 / data.grandTotal).toFixed(1)}%` : '0%'} variant="warning" formatted={false} />
      </Row>
      <Row>
        <BalanceCard title="Số dư toàn hệ thống" amount={data.grandTotalAmount} reward={data.grandTotalRewardAmount} />
        <BalanceCard title="Số dư theo bộ lọc" amount={data.totalAmount} reward={data.totalRewardAmount} />
      </Row>
      <Card border="light" className="shadow-sm">
        <Table responsive className="align-items-center table-bordered table-hover">
          <thead className='text-center'>
            <tr>
              <th scope="col">Thao tác</th>
              <th scope="col">Tên khách hàng</th>
              <th scope="col">Số điện thoại</th>
              <th scope="col">Số dư</th>
              <th scope="col">Tổng thưởng</th>
              <th scope="col">Lần cuối mua vé</th>
              <th scope="col">Ngày đăng ký</th>
              <th scope="col">Trạng thái</th>
            </tr>
          </thead>
          <tbody>
            {data.list && data.list.map((pv, index) => <TableRow rIndex={index} onStatusChange={onStatusChange} assignPin={onAssignPin} onShowUserAmount={() => onShowUserAmount(pv.phone)} key={`user-status-${pv.id}`} {...pv} />)}
            {data.list && data.list.length === 0 && (
              <tr><td colSpan={8} className="text-center text-muted py-4">Không tìm thấy khách hàng phù hợp</td></tr>
            )}
          </tbody>
        </Table>
        <Card.Footer className='flex-row'>
          <Row className="align-items-center">
            <Col>
              <Pagination
                totalPage={data.totalPage}
                currentPage={page}
                onPageChange={(i) => {
                  setPage(i)
                }}
              />
            </Col>
          </Row>
        </Card.Footer>
      </Card>
      <UserAmount
        show={modalShow}
        phone={userPhoneRef.current}
        onHide={() => setModalShow(false)}
      />
      <PinModal
        show={pinModalShow}
        userId={_userId.current}
        onHide={() => setPinModalShow(false)}
      />
    </>
  );
};

export default React.memo(_Table)
